import React from 'react'
import type { MetaDataHighlight, SearchResultFobEvent } from '@core/Areas/Search/types'
import { ResultContentListRow } from '@core/Areas/Search/Components/Common/ResultContentListRow'
import { HighlightDisplay } from '@core/Areas/Search/Components/Common/HighlightDisplay'
import { LocationTime } from '../Common/LocationTime'

export const FobEventResult: React.FC<{
  searchResult: SearchResultFobEvent
  highlights: MetaDataHighlight
}> = ({ searchResult, highlights }) => {
  const { fobEvent } = searchResult
  const advertisedStartTime = fobEvent.isStartTimeRelevant ? fobEvent.startTime : undefined

  return (
    <ResultContentListRow
      testId='SearchResultFobEvent'
      topContent={
        <LocationTime
          locationName={fobEvent.raceCourse}
          raceNumber={fobEvent.number}
          advertisedStartTime={advertisedStartTime}
          code={fobEvent.contestType}
          status={fobEvent.result ?? fobEvent.status}
          highlights={highlights}
          highlightKey='fobEvent.raceCourse'
        />
      }
      primaryText={
        <HighlightDisplay
          displayText={fobEvent.name}
          highlightKey='fobEvent.name'
          highlights={searchResult.metadata.highlights}
        />
      }
    />
  )
}
